export const iconFontAwesomeBuildingsIndustry = (
	<i className="fa-solid fa-industry"></i>
);
